import { render, staticRenderFns } from "./AreaForm.vue?vue&type=template&id=6039ab49&scoped=true"
import script from "./AreaForm.vue?vue&type=script&lang=js"
export * from "./AreaForm.vue?vue&type=script&lang=js"
import style0 from "./AreaForm.vue?vue&type=style&index=0&id=6039ab49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039ab49",
  null
  
)

export default component.exports